import { useEffect, useState } from "react";
import { Trophy, Medal } from "@phosphor-icons/react";
import client from "../lib/api";

const money = (c) => `$${((c || 0) / 100).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
const monthLabel = (m) => (m ? new Date(`${m}-15T12:00:00`).toLocaleDateString("en-US", { month: "long", year: "numeric" }) : "");

export function PartnerLeaderboard({ highlightCode = "", compact = false }) {
  const [data, setData] = useState(null);
  useEffect(() => { client.get("/public/partner-leaderboard").then((r) => setData(r.data)).catch(() => setData({ leaders: [], bonus_tiers: [] })); }, []);
  if (!data) return null;
  return (
    <div className="card-surface p-5 sm:p-6" data-testid="partner-leaderboard">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-neutral-500 font-bold"><Trophy size={14} weight="fill" className="text-[#FF5A1F]" /> Leaderboard · {monthLabel(data.month)}</div>
        <div className="text-[11px] text-neutral-500">ranked by paying customers this month</div>
      </div>
      {data.leaders.length === 0 ? (
        <div className="text-sm text-neutral-500" data-testid="partner-leaderboard-empty">Nobody on the board yet this month — the first paying customer takes #1.</div>
      ) : (
        <ol className="space-y-1.5" data-testid="partner-leaderboard-list">
          {data.leaders.map((l) => (
            <li key={l.code} className={`flex items-center gap-3 rounded-lg px-3 py-2 text-sm ${l.code === highlightCode ? "bg-[#FF5A1F]/10 border border-[#FF5A1F]/40" : "bg-white/[0.02]"}`} data-testid={`partner-leaderboard-row-${l.code}`}>
              <span className={`font-display font-bold w-6 ${l.rank <= 3 ? "text-[#FF5A1F]" : "text-neutral-500"}`}>{l.rank <= 3 ? <Medal size={18} weight="fill" /> : l.rank}</span>
              <span className="text-white font-semibold truncate">{l.name}{l.code === highlightCode ? " (you)" : ""}</span>
              <span className="text-neutral-500 text-xs hidden sm:inline">{l.type}</span>
              <span className="ml-auto font-bold text-emerald-300">{l.paid_this_month} paying</span>
              {l.bonus_cents > 0 && <span className="text-xs text-[#FF5A1F] font-bold">+{money(l.bonus_cents)} bonus</span>}
            </li>
          ))}
        </ol>
      )}
      {!compact && (
        <div className="mt-4 pt-3 border-t border-white/[0.06] flex flex-wrap gap-2" data-testid="partner-bonus-tiers">
          <span className="text-xs text-neutral-500 mr-1">Monthly bonus tiers:</span>
          {data.bonus_tiers.map((t) => (
            <span key={t.at} className="text-xs rounded-full border border-white/15 px-2.5 py-0.5 text-neutral-300"><b className="text-white">{t.at}</b> paying → <b className="text-[#FF5A1F]">+{money(t.bonus_cents)}</b></span>
          ))}
          <span className="text-[11px] text-neutral-500 w-full">On top of your per-customer payout. Bonuses reset every month — so do the standings.</span>
        </div>
      )}
    </div>
  );
}
